(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3679],{

/***/ 6789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Trans; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3882);
/* harmony import */ var _useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3792);


var tagRe = /<(\w+)>(.*?)<\/\1>|<(\w+)\/>/;
var nlRe = /(?:\r\n|\r|\n)/g;
function getElements(parts) {
    if (!parts.length)
        return [];
    var _a = parts.slice(0, 4), paired = _a[0], children = _a[1], unpaired = _a[2], after = _a[3];
    return [
        [(paired || unpaired), children || '', after],
    ].concat(getElements(parts.slice(4, parts.length)));
}
function formatElements(value, elements) {
    if (elements === void 0) { elements = []; }
    var parts = value.replace(nlRe, '').split(tagRe);
    if (parts.length === 1)
        return value;
    var tree = [];
    var before = parts.shift();
    if (before)
        tree.push(before);
    getElements(parts).forEach(function (_a, realIndex) {
        var key = _a[0], children = _a[1], after = _a[2];
        var element = elements[key] || react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
        tree.push((0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(element, { key: realIndex }, children ? formatElements(children, elements) : element.props.children));
        if (after)
            tree.push(after);
    });
    return tree;
}
function Trans(_a) {
    var i18nKey = _a.i18nKey, values = _a.values, components = _a.components, fallback = _a.fallback, defaultTrans = _a.defaultTrans;
    var _b = (0,_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), t = _b.t, lang = _b.lang;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var text = t(i18nKey, values, { fallback: fallback, default: defaultTrans });
        if (!components || components.length === 0)
            return text;
        return formatElements(text, components);
    }, [i18nKey, values, components, lang]);
    return result;
}


/***/ }),

/***/ 0:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/costs-calculation/introduction",
      function () {
        return __webpack_require__(6738);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ NewCalculationButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2087);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3792);
/* harmony import */ var _NavButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8444);



var NewCalculationButton = function(param) {
    var disabled = param.disabled, onClick = param.onClick;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('common').t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* .StyledButton */ .S, {
        size: "large",
        action: "secondary",
        disabled: disabled,
        onClick: onClick,
        children: t('buttons.new')
    }));
};


/***/ }),

/***/ 7477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ResumeCalculationButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2087);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3792);
/* harmony import */ var _NavButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8444);



var ResumeCalculationButton = function(param) {
    var disabled = param.disabled, onClick = param.onClick;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('common').t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavButton__WEBPACK_IMPORTED_MODULE_2__/* .StyledButton */ .S, {
        size: "large",
        action: "primary",
        disabled: disabled,
        onClick: onClick,
        children: t('buttons.resume')
    }));
};


/***/ }),

/***/ 4187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony export ButtonContainer */
/* harmony import */ var _styles_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6832);

var Container = (0,_styles_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', {
    width: '773px',
    height: '784px',
    padding: '41px',
    backgroundColor: '$white',
    borderRadius: '$radius',
    boxShadow: '$card',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
var Text = (0,_styles_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', {
    textAlign: 'center',
    marginBottom: '25px',
    overflow: 'auto',
    maxHeight: '85%'
});
var ButtonContainer = (0,_styles_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
});


/***/ }),

/***/ 6738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2087);
/* harmony import */ var _next_translate_root_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7773);
/* harmony import */ var _next_translate_root_i18n__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_next_translate_root_i18n__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_appWithI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2128);
/* harmony import */ var _Introduction_Introduction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4187);
/* harmony import */ var _Buttons_NewCalculationButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1022);
/* harmony import */ var _styles_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6832);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3792);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6789);
/* harmony import */ var mobx_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2318);
/* harmony import */ var _Buttons_ResumeCalculationButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7477);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5634);
/* harmony import */ var _stores_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7474);

// @ts-ignore

// @ts-ignore

// @ts-ignore









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ButtonContainer = (0,_styles_config__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .zo)('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
});
var Home = (0,mobx_react__WEBPACK_IMPORTED_MODULE_11__/* .observer */ .Pi)(function() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('common').t;
    var ref = (0,_stores_index__WEBPACK_IMPORTED_MODULE_10__/* .useStore */ .o)(), costStore = ref.costStore, formStore = ref.formStore, authStore = ref.authStore;
    var newCostsCalculation = function() {
        costStore.createNewCostsCalculationForm();
        next_router__WEBPACK_IMPORTED_MODULE_9__["default"].push('/costs-calculation/basic-information/internship-duration');
    };
    var resumeCostsCalculation = function() {
        next_router__WEBPACK_IMPORTED_MODULE_9__["default"].push(costStore.currentUrl || '/costs-calculation/basic-information/internship-duration');
    };
    var resumeCalculationAction = function() {
        if (authStore.hasToken) {
            return costStore.hasLocalForm ? formStore.setMoveCalculationModalIsOpen : resumeCostsCalculation;
        } else {
            return formStore.setResumeCalculationModalGuestIsOpen;
        }
    };
    var newCalculationAction = function() {
        if (costStore.hasLocalForm && authStore.hasToken) {
            return formStore.setMoveCalculationModalIsOpen;
        } else if (costStore.hasForm) {
            return formStore.setNewCalculationModalIsOpen;
        } else if (authStore.hasToken) {
            return newCostsCalculation;
        } else {
            return formStore.setNewCalculationModalGuestIsOpen;
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Introduction_Introduction__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Introduction_Introduction__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    i18nKey: "common:introduction-instrument-2",
                    components: {
                        br: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons_ResumeCalculationButton__WEBPACK_IMPORTED_MODULE_8__/* .ResumeCalculationButton */ .e, {
                        disabled: !costStore.hasForm,
                        onClick: resumeCalculationAction()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons_NewCalculationButton__WEBPACK_IMPORTED_MODULE_4__/* .NewCalculationButton */ .m, {
                        onClick: newCalculationAction()
                    })
                ]
            })
        ]
    }));
});
var __Page_Next_Translate__ = Home;
// @ts-ignore
/* harmony default export */ __webpack_exports__["default"] = ((0,next_translate_appWithI18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(__Page_Next_Translate__, _objectSpread({}, (_next_translate_root_i18n__WEBPACK_IMPORTED_MODULE_1___default()), {
    // @ts-ignore
    isLoader: true,
    // @ts-ignore
    skipInitialProps: false,
    // @ts-ignore
    loadLocaleFrom: function(l, n) {
        return __webpack_require__(242)("./".concat(l, "/").concat(n)).then(function(m) {
            return m.default;
        });
    }
}))); // @ts-ignore


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(0); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);